// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

/**
 * APlusContentModule
 */
export const zAPlusContentModule = z.object({
    type: z.string(),
    count: z.int().gte(1)
});

/**
 * APlusContentStatus
 *
 * `unknown` means the ISBN maps to no ASIN, so Amazon has nothing to check.
 */
export const zAPlusContentStatus = z.enum([
    'published',
    'none',
    'unknown'
]);

/**
 * APlusGenerationSummary
 */
export const zAPlusGenerationSummary = z.object({
    status: z.enum([
        'generating',
        'failed',
        'generated'
    ])
});

/**
 * AccountOrganisationFileRequest
 */
export const zAccountOrganisationFileRequest = z.object({
    upload: z.string().nullish()
});

/**
 * AccountOrganisationFileResponse
 */
export const zAccountOrganisationFileResponse = z.object({
    name: z.string(),
    size: z.int(),
    url: z.string(),
    date: z.iso.datetime().nullish()
});

/**
 * AccountUserApiKeyRequest
 */
export const zAccountUserApiKeyRequest = z.object({
    name: z.string().nullish()
});

/**
 * AccountUserCreateRequest
 */
export const zAccountUserCreateRequest = z.object({
    email: z.string(),
    givenName: z.string().nullish(),
    familyName: z.string().nullish(),
    deletedAt: z.iso.datetime().nullish()
});

/**
 * AcpAvailability
 */
export const zAcpAvailability = z.object({
    available: z.boolean(),
    status: z.enum([
        'in_stock',
        'backorder',
        'preorder',
        'out_of_stock',
        'discontinued'
    ])
});

/**
 * AcpBarcode
 */
export const zAcpBarcode = z.object({
    type: z.literal('gtin'),
    value: z.string()
});

/**
 * AcpCategory
 */
export const zAcpCategory = z.object({
    value: z.string(),
    taxonomy: z.string().nullish()
});

/**
 * AcpDescription
 */
export const zAcpDescription = z.object({
    plain: z.string().nullish(),
    html: z.string().nullish(),
    markdown: z.string().nullish()
});

/**
 * AcpExportRequest
 */
export const zAcpExportRequest = z.object({
    count: z.int().gte(0).nullish()
});

/**
 * AcpExportResponse
 */
export const zAcpExportResponse = z.object({
    exportId: z.string()
});

/**
 * AcpLink
 */
export const zAcpLink = z.object({
    type: z.enum([
        'privacy_policy',
        'terms_of_service',
        'refund_policy',
        'shipping_policy',
        'faq'
    ]),
    url: z.string(),
    title: z.string().nullish()
});

/**
 * AcpMedia
 */
export const zAcpMedia = z.object({
    type: z.literal('image'),
    url: z.string(),
    alt_text: z.string().nullish(),
    width: z.int().nullish(),
    height: z.int().nullish()
});

/**
 * AcpPrice
 */
export const zAcpPrice = z.object({
    amount: z.int().gte(0),
    currency: z.string().length(3)
});

/**
 * AcpSeller
 */
export const zAcpSeller = z.object({
    name: z.string().nullish(),
    links: z.array(zAcpLink).nullish()
});

/**
 * AcpVariantOption
 */
export const zAcpVariantOption = z.object({
    name: z.string(),
    value: z.string()
});

/**
 * AcpVariant
 */
export const zAcpVariant = z.object({
    id: z.string(),
    title: z.string(),
    description: zAcpDescription.nullish(),
    url: z.string().nullish(),
    barcodes: z.array(zAcpBarcode).nullish(),
    price: zAcpPrice.nullish(),
    list_price: zAcpPrice.nullish(),
    availability: zAcpAvailability.nullish(),
    categories: z.array(zAcpCategory).nullish(),
    condition: z.array(z.string()).nullish(),
    variant_options: z.array(zAcpVariantOption).nullish(),
    media: z.array(zAcpMedia).nullish(),
    seller: zAcpSeller.nullish()
});

/**
 * AcpProduct
 */
export const zAcpProduct = z.object({
    id: z.string(),
    title: z.string().nullish(),
    description: zAcpDescription.nullish(),
    url: z.string().nullish(),
    media: z.array(zAcpMedia).nullish(),
    variants: z.array(zAcpVariant).min(1)
});

/**
 * AgeRangeBound
 */
export const zAgeRangeBound = z.object({
    min: z.int(),
    max: z.int()
});

/**
 * AgeRangeAvailableBounds
 *
 * Per age-type slider bounds; null when no product carries that type.
 */
export const zAgeRangeAvailableBounds = z.object({
    interest_age_months: zAgeRangeBound.nullish(),
    interest_age_years: zAgeRangeBound.nullish(),
    reading_age_years: zAgeRangeBound.nullish()
});

/**
 * AgeType
 */
export const zAgeType = z.enum([
    'interest_age_months',
    'interest_age_years',
    'reading_age_years'
]);

/**
 * AgeRangeFilter
 */
export const zAgeRangeFilter = z.object({
    age_type: zAgeType,
    gte: z.int().gte(0),
    lte: z.int().gte(0)
});

/**
 * AggregationResult
 */
export const zAggregationResult = z.object({
    key: z.string(),
    doc_count: z.int(),
    label: z.string().nullish(),
    kind: z.string().nullish(),
    seq: z.int().nullish(),
    subject_code: z.string().nullish(),
    subject_label: z.string().nullish()
});

/**
 * AggregationBucket
 */
export const zAggregationBucket = z.object({
    field: z.string(),
    buckets: z.array(zAggregationResult)
});

/**
 * AmazonSalesIsbnBucket
 *
 * One format's Amazon signals within a bucket. Null fields mean no source rows.
 */
export const zAmazonSalesIsbnBucket = z.object({
    units: z.int().nullish(),
    revenue: z.number().nullish(),
    pageViews: z.int().nullish(),
    conversionRate: z.number().nullish(),
    salesRank: z.int().nullish(),
    salesRankDate: z.string().nullish(),
    worstSalesRank: z.int().nullish(),
    worstSalesRankDate: z.string().nullish()
});

/**
 * AmazonSalesBucket
 *
 * One time bucket of Amazon signals. `byIsbn` is set on bundle reads.
 */
export const zAmazonSalesBucket = z.object({
    date: z.string(),
    units: z.int().nullable(),
    revenue: z.number().nullable(),
    pageViews: z.int().nullable(),
    conversionRate: z.number().nullable(),
    salesRank: z.int().nullable(),
    salesRankDate: z.string().nullable(),
    worstSalesRank: z.int().nullable(),
    worstSalesRankDate: z.string().nullable(),
    byIsbn: z.record(z.string(), zAmazonSalesIsbnBucket).nullish()
});

/**
 * AmazonSalesSummary
 *
 * Window totals. Share compares Amazon units to the market panel.
 */
export const zAmazonSalesSummary = z.object({
    totalUnits: z.int(),
    totalRevenue: z.number().nullable(),
    averageConversionRate: z.number().nullable(),
    totalPageViews: z.int().nullable(),
    bestRank: z.int().nullable(),
    worstRank: z.int().nullable(),
    amazonShareOfTotalUnits: z.number().nullable()
});

/**
 * ApiResponseAccountOrganisationFileResponseStatus200
 */
export const zApiResponseAccountOrganisationFileResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zAccountOrganisationFileResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ApiResponseMessage
 */
export const zApiResponseMessage = z.object({
    message: z.string()
});

/**
 * ApiResponseApiResponseMessageStatus200
 */
export const zApiResponseApiResponseMessageStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zApiResponseMessage.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ApiResponseApiResponseMessageStatus400
 */
export const zApiResponseApiResponseMessageStatus400 = z.object({
    success: z.boolean().optional().default(false),
    data: zApiResponseMessage.nullish(),
    code: z.int().optional().default(400)
});

/**
 * ApiResponseApiResponseMessageStatus401
 */
export const zApiResponseApiResponseMessageStatus401 = z.object({
    success: z.boolean().optional().default(false),
    data: zApiResponseMessage.nullish(),
    code: z.int().optional().default(401)
});

/**
 * ApiResponseApiResponseMessageStatus403
 */
export const zApiResponseApiResponseMessageStatus403 = z.object({
    success: z.boolean().optional().default(false),
    data: zApiResponseMessage.nullish(),
    code: z.int().optional().default(403)
});

/**
 * ApiResponseApiResponseMessageStatus404
 */
export const zApiResponseApiResponseMessageStatus404 = z.object({
    success: z.boolean().optional().default(false),
    data: zApiResponseMessage.nullish(),
    code: z.int().optional().default(404)
});

/**
 * ApiResponseApiResponseMessageStatus429
 */
export const zApiResponseApiResponseMessageStatus429 = z.object({
    success: z.boolean().optional().default(false),
    data: zApiResponseMessage.nullish(),
    code: z.int().optional().default(429)
});

/**
 * ApiResponseApiResponseMessageStatus500
 */
export const zApiResponseApiResponseMessageStatus500 = z.object({
    success: z.boolean().optional().default(false),
    data: zApiResponseMessage.nullish(),
    code: z.int().optional().default(500)
});

/**
 * ApiResponseApiResponseMessageStatus502
 */
export const zApiResponseApiResponseMessageStatus502 = z.object({
    success: z.boolean().optional().default(false),
    data: zApiResponseMessage.nullish(),
    code: z.int().optional().default(502)
});

/**
 * ApiResponseApiResponseMessageStatus503
 */
export const zApiResponseApiResponseMessageStatus503 = z.object({
    success: z.boolean().optional().default(false),
    data: zApiResponseMessage.nullish(),
    code: z.int().optional().default(503)
});

/**
 * AuthorFilter
 */
export const zAuthorFilter = z.object({
    authors: z.array(z.string()).min(1)
});

/**
 * BisacCode
 *
 * A BISAC subject code from the catalogue.
 */
export const zBisacCode = z.object({
    code: z.string(),
    headingPath: z.array(z.string()),
    seeAlso: z.array(z.string()),
    seq: z.int()
});

/**
 * BisacCodesFilter
 */
export const zBisacCodesFilter = z.object({
    codes: z.array(z.string()).min(1)
});

/**
 * BisacCodesResponse
 *
 * Response model for the whole BISAC catalogue (/bisac/codes).
 */
export const zBisacCodesResponse = z.object({
    edition: z.string(),
    codes: z.array(zBisacCode)
});

/**
 * ApiResponseBisacCodesResponseStatus200
 */
export const zApiResponseBisacCodesResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zBisacCodesResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * BisacSearchHit
 *
 * A BISAC code that matched a search, with the matched heading text marked.
 */
export const zBisacSearchHit = z.object({
    code: z.string(),
    headingPath: z.array(z.string()),
    seeAlso: z.array(z.string()),
    seq: z.int(),
    highlightedHeading: z.string().nullish()
});

/**
 * BisacSearchResponse
 *
 * Response model for BISAC search (/bisac/search).
 */
export const zBisacSearchResponse = z.object({
    codes: z.array(zBisacSearchHit)
});

/**
 * ApiResponseBisacSearchResponseStatus200
 */
export const zApiResponseBisacSearchResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zBisacSearchResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * BookSalesMarketBucket
 *
 * Units and native-currency revenue for one market within one bucket.
 */
export const zBookSalesMarketBucket = z.object({
    units: z.int(),
    revenue: z.number().nullable()
});

/**
 * BookSalesIsbnBucket
 *
 * One format's contribution to a bucket, with per-market revenue grain.
 */
export const zBookSalesIsbnBucket = z.object({
    byMarket: z.record(z.string(), zBookSalesMarketBucket)
});

/**
 * BookSalesBucket
 *
 * One time bucket with per-market totals. `byIsbn` is set on bundle reads.
 */
export const zBookSalesBucket = z.object({
    date: z.string(),
    byMarket: z.record(z.string(), zBookSalesMarketBucket),
    byIsbn: z.record(z.string(), zBookSalesIsbnBucket).nullable()
});

/**
 * BookSalesMarketMeta
 *
 * A market present in the result and the currency its revenue is in.
 */
export const zBookSalesMarketMeta = z.object({
    market: z.string(),
    currency: z.string()
});

/**
 * BookSalesPeak
 *
 * Best-revenue day within the window, independent of chart granularity.
 *
 * The summary cards use this so the peak date is the actual day, not the
 * Monday week-start of a weekly bucket.
 */
export const zBookSalesPeak = z.object({
    date: z.string(),
    byMarket: z.record(z.string(), zBookSalesMarketBucket)
});

/**
 * EvaluationRequest
 */
export const zEvaluationRequest = z.object({
    requestedProducts: z.union([
        z.literal('ALL'),
        z.array(z.string())
    ]),
    mode: z.enum(['SYNC', 'ASYNC']).optional().default('ASYNC')
});

/**
 * FailedRequestInfo
 */
export const zFailedRequestInfo = z.object({
    productId: z.string(),
    reason: z.string()
});

/**
 * FilterOperator
 */
export const zFilterOperator = z.enum([
    'gt',
    'lt',
    'eq'
]);

/**
 * BisacCodeCountFilter
 */
export const zBisacCodeCountFilter = z.object({
    operator: zFilterOperator,
    value: z.int().gte(0)
});

/**
 * DescriptionLengthFilter
 */
export const zDescriptionLengthFilter = z.object({
    operator: zFilterOperator,
    value: z.int().gte(0)
});

/**
 * DescriptionWordCountFilter
 */
export const zDescriptionWordCountFilter = z.object({
    operator: zFilterOperator,
    value: z.int().gte(0)
});

/**
 * FirestoreGenerationStatus
 */
export const zFirestoreGenerationStatus = z.enum([
    'IMPORTED',
    'REQUESTED',
    'GENERATING',
    'GENERATED',
    'PROCESSING',
    'COMPLETED',
    'CANCELLED',
    'ERROR'
]);

/**
 * FirestoreGenerationStatusCode
 */
export const zFirestoreGenerationStatusCode = z.enum([
    '100',
    '102',
    '200',
    '402',
    '422',
    '451',
    '499',
    '500'
]);

/**
 * EvaluationResponse
 */
export const zEvaluationResponse = z.object({
    id: z.string(),
    status: zFirestoreGenerationStatus,
    statusCode: zFirestoreGenerationStatusCode.nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime().nullable(),
    mode: z.enum(['SYNC', 'ASYNC']).optional().default('ASYNC'),
    requestedProducts: z.union([
        z.literal('ALL'),
        z.array(z.string())
    ]),
    file: z.record(z.string(), z.unknown()).nullish()
});

/**
 * ApiResponseEvaluationResponseStatus200
 */
export const zApiResponseEvaluationResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zEvaluationResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * EvaluationsResponse
 */
export const zEvaluationsResponse = z.object({
    items: z.array(zEvaluationResponse)
});

/**
 * ApiResponseEvaluationsResponseStatus200
 */
export const zApiResponseEvaluationsResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zEvaluationsResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * FirestoreOrganisationAcpSettings
 */
export const zFirestoreOrganisationAcpSettings = z.object({
    feed_id: z.string().nullish(),
    account_id: z.string().nullish(),
    target_merchant: z.string().nullish(),
    target_country: z.string().nullish()
});

/**
 * FirestoreOrganisationLanguage
 */
export const zFirestoreOrganisationLanguage = z.enum([
    'en-GB',
    'en-US',
    'de-DE'
]);

/**
 * FirestoreOrganisationMarketplace
 */
export const zFirestoreOrganisationMarketplace = z.enum([
    'UK',
    'US',
    'GER',
    'AU',
    'NONE'
]);

/**
 * FirestoreOrganisationSalesDataLake
 *
 * Which sales data lake an organisation reads from.
 */
export const zFirestoreOrganisationSalesDataLake = z.enum([
    'MMDE',
    'PMUK',
    'MMUS',
    'DISABLED'
]);

/**
 * FirestoreOrganisationTargetGroups
 */
export const zFirestoreOrganisationTargetGroups = z.object({
    name: z.string(),
    description: z.string()
});

/**
 * FirestoreProductActionsValue
 */
export const zFirestoreProductActionsValue = z.object({
    status: zFirestoreGenerationStatus.nullish(),
    statusCode: zFirestoreGenerationStatusCode.nullish(),
    msg: z.string().optional().default('')
});

/**
 * FirestoreProductActionsDescriptionsActions
 */
export const zFirestoreProductActionsDescriptionsActions = z.object({
    generate: zFirestoreProductActionsValue.optional()
});

/**
 * FirestoreProductActionsDescriptions
 */
export const zFirestoreProductActionsDescriptions = z.object({
    active: z.boolean().optional().default(false),
    errored: z.boolean().optional().default(false),
    actions: z.record(z.string(), zFirestoreProductActionsDescriptionsActions).optional()
});

/**
 * FirestoreProductActionsKeywordsActions
 */
export const zFirestoreProductActionsKeywordsActions = z.object({
    rank: zFirestoreProductActionsValue.nullish(),
    generate: zFirestoreProductActionsValue.nullish(),
    autoFill: zFirestoreProductActionsValue.nullish()
});

/**
 * FirestoreProductActionsKeywords
 */
export const zFirestoreProductActionsKeywords = z.object({
    active: z.boolean().optional().default(false),
    errored: z.boolean().optional().default(false),
    actions: zFirestoreProductActionsKeywordsActions.optional()
});

/**
 * FirestoreProductActionsManuscriptActions
 */
export const zFirestoreProductActionsManuscriptActions = z.object({
    analyse: zFirestoreProductActionsValue.nullish()
});

/**
 * FirestoreProductActionsManuscript
 */
export const zFirestoreProductActionsManuscript = z.object({
    active: z.boolean().optional().default(false),
    errored: z.boolean().optional().default(false),
    actions: zFirestoreProductActionsManuscriptActions.nullish()
});

/**
 * FirestoreProductActionsSubtitleActions
 */
export const zFirestoreProductActionsSubtitleActions = z.object({
    generate: zFirestoreProductActionsValue.nullish()
});

/**
 * FirestoreProductActionsSubtitle
 */
export const zFirestoreProductActionsSubtitle = z.object({
    active: z.boolean().optional().default(false),
    errored: z.boolean().optional().default(false),
    actions: zFirestoreProductActionsSubtitleActions.nullish()
});

/**
 * FirestoreProductActionsThemaActions
 */
export const zFirestoreProductActionsThemaActions = z.object({
    generate: zFirestoreProductActionsValue.nullish()
});

/**
 * FirestoreProductActionsThema
 */
export const zFirestoreProductActionsThema = z.object({
    active: z.boolean().optional().default(false),
    errored: z.boolean().optional().default(false),
    actions: zFirestoreProductActionsThemaActions.nullish()
});

/**
 * FirestoreProductActions
 */
export const zFirestoreProductActions = z.object({
    active: z.boolean().optional().default(false),
    errored: z.boolean().optional().default(false),
    keywords: zFirestoreProductActionsKeywords.optional(),
    descriptions: zFirestoreProductActionsDescriptions.nullish(),
    thema: zFirestoreProductActionsThema.nullish(),
    manuscript: zFirestoreProductActionsManuscript.nullish(),
    subtitle: zFirestoreProductActionsSubtitle.nullish()
});

/**
 * FirestoreProductAgeRange
 *
 * A normalized audience age range; either bound may be open-ended.
 */
export const zFirestoreProductAgeRange = z.object({
    gte: z.int().nullish(),
    lte: z.int().nullish()
});

/**
 * FirestoreProductAgeRanges
 *
 * ONIX List 30 qualifiers 16/17/18 (see ``get_age_ranges``).
 */
export const zFirestoreProductAgeRanges = z.object({
    interestAgeMonths: zFirestoreProductAgeRange.nullish(),
    interestAgeYears: zFirestoreProductAgeRange.nullish(),
    readingAgeYears: zFirestoreProductAgeRange.nullish()
});

/**
 * FirestoreProductCategorization
 */
export const zFirestoreProductCategorization = z.object({
    fiction: z.boolean().optional().default(true),
    nonFiction: z.boolean().optional().default(true),
    children: z.boolean().optional().default(true),
    updatedAt: z.iso.datetime().nullish(),
    inferredFrom: z.enum(['THEMA', 'LLM']).nullish()
});

/**
 * FirestoreProductDescription
 */
export const zFirestoreProductDescription = z.object({
    hash: z.string().optional().default(''),
    default: z.boolean().optional().default(false),
    textGenerated: z.string().optional().default(''),
    text: z.string().optional().default(''),
    textFormat: z.string().optional().default(''),
    textType: z.string().optional().default(''),
    audiences: z.array(z.string()).optional().default([])
});

/**
 * FirestoreProductDimensions
 *
 * Lengths in mm, weight in grams; keys match ``normalize_dimensions`` output.
 */
export const zFirestoreProductDimensions = z.object({
    width: z.number().nullish(),
    height: z.number().nullish(),
    thickness: z.number().nullish(),
    weight: z.number().nullish(),
    pages: z.number().nullish(),
    flaps: z.number().nullish()
});

/**
 * FirestoreProductIdentifier
 */
export const zFirestoreProductIdentifier = z.object({
    type: z.string(),
    value: z.string()
});

/**
 * FirestoreProductImages
 */
export const zFirestoreProductImages = z.object({
    frontCoverUrl: z.string().optional().default(''),
    backCoverUrl: z.string().optional().default(''),
    supportingResources: z.array(z.record(z.string(), z.unknown())).optional()
});

/**
 * FirestoreProductImportData
 */
export const zFirestoreProductImportData = z.object({
    importId: z.string(),
    productsImportId: z.string(),
    objectName: z.string(),
    folderName: z.string(),
    fileName: z.string(),
    chunkId: z.string().nullish()
});

/**
 * FirestoreProductManuscriptAnalysis
 */
export const zFirestoreProductManuscriptAnalysis = z.object({
    result: z.string().nullish(),
    generatedContentId: z.string().nullish(),
    generatedAt: z.iso.datetime().nullish(),
    generationRequestId: z.string().nullish()
});

/**
 * FirestoreProductManuscript
 */
export const zFirestoreProductManuscript = z.object({
    filename: z.string(),
    uploadedAt: z.iso.datetime(),
    analysis: zFirestoreProductManuscriptAnalysis.nullish()
});

/**
 * FirestoreProductPublisher
 */
export const zFirestoreProductPublisher = z.object({
    name: z.string(),
    role: z.string().nullable()
});

/**
 * FirestoreProductQuote
 */
export const zFirestoreProductQuote = z.object({
    text: z.string().optional().default(''),
    source: z.string().optional().default('')
});

/**
 * FirestoreProductSeriesIdentifier
 */
export const zFirestoreProductSeriesIdentifier = z.object({
    type: z.string(),
    idTypeName: z.string().nullish(),
    value: z.string()
});

/**
 * FirestoreProductSubtitleCandidate
 */
export const zFirestoreProductSubtitleCandidate = z.object({
    subtitle: z.string(),
    reasoning: z.string(),
    isBestChoice: z.boolean().nullish(),
    bestChoiceReasoning: z.string().nullish()
});

/**
 * FirestoreUserApiKey
 */
export const zFirestoreUserApiKey = z.object({
    identifier: z.string(),
    name: z.string().nullish(),
    apiKeyShort: z.string(),
    createdAt: z.iso.datetime()
});

/**
 * AccountUserApiKeyCreatedResponse
 */
export const zAccountUserApiKeyCreatedResponse = z.object({
    api_key: z.string(),
    user_api_key: zFirestoreUserApiKey
});

/**
 * AccountUserApiKeysResponse
 */
export const zAccountUserApiKeysResponse = z.object({
    items: z.array(zFirestoreUserApiKey).optional().default([])
});

/**
 * ApiResponseAccountUserApiKeyCreatedResponseStatus200
 */
export const zApiResponseAccountUserApiKeyCreatedResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zAccountUserApiKeyCreatedResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ApiResponseAccountUserApiKeysResponseStatus200
 */
export const zApiResponseAccountUserApiKeysResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zAccountUserApiKeysResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * GalleyCharacter
 */
export const zGalleyCharacter = z.object({
    name: z.string().nullish(),
    aliases: z.array(z.string()).optional().default([]),
    role: z.string().nullish(),
    pronouns: z.string().nullish(),
    age_label: z.string().nullish(),
    description: z.string().nullish()
});

/**
 * GalleyEssenceFilters
 */
export const zGalleyEssenceFilters = z.object({
    genres: z.array(z.string()).optional().default([]),
    tropes: z.array(z.string()).optional().default([]),
    countries: z.array(z.string()).optional().default([]),
    cities: z.array(z.string()).optional().default([]),
    decades: z.array(z.int()).optional().default([]),
    year_from: z.int().nullish(),
    year_to: z.int().nullish(),
    character_roles: z.array(z.string()).optional().default([]),
    protagonist_pronouns: z.array(z.string()).optional().default([])
});

/**
 * GalleyPrimarySetting
 */
export const zGalleyPrimarySetting = z.object({
    label: z.string().nullish(),
    place: z.string().nullish(),
    period: z.string().nullish(),
    city: z.string().nullish(),
    country_name: z.string().nullish(),
    decades: z.array(z.int()).optional().default([])
});

/**
 * GalleyEssenceSummary
 */
export const zGalleyEssenceSummary = z.object({
    primary_setting: zGalleyPrimarySetting.nullish(),
    genres: z.array(z.string()).optional().default([]),
    tropes: z.array(z.string()).optional().default([]),
    countries: z.array(z.string()).optional().default([]),
    decades: z.array(z.int()).optional().default([])
});

/**
 * GalleyProjectBook
 */
export const zGalleyProjectBook = z.object({
    product_id: z.string(),
    title: z.string().nullish(),
    isbn: z.string().nullish(),
    format: z.string().nullish(),
    published_at: z.iso.datetime().nullish()
});

/**
 * GalleyProject
 */
export const zGalleyProject = z.object({
    id: z.string(),
    name: z.string(),
    created_at: z.iso.datetime(),
    user_id: z.string(),
    product_ids: z.array(z.string()),
    books: z.array(zGalleyProjectBook)
});

/**
 * ApiResponseGalleyProjectStatus200
 */
export const zApiResponseGalleyProjectStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zGalleyProject.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ApiResponseGalleyProjectStatus201
 */
export const zApiResponseGalleyProjectStatus201 = z.object({
    success: z.boolean().optional().default(true),
    data: zGalleyProject.nullish(),
    code: z.int().optional().default(201)
});

/**
 * GalleyProjectCreateRequest
 */
export const zGalleyProjectCreateRequest = z.object({
    name: z.string().min(1).max(200),
    product_ids: z.array(z.string().min(1).regex(/^[^\/]+$/)).min(1).max(250)
});

/**
 * GalleySeasonalEventPrompt
 */
export const zGalleySeasonalEventPrompt = z.object({
    prompt_id: z.string(),
    text: z.string()
});

/**
 * GalleySetting
 */
export const zGalleySetting = z.object({
    label: z.string().nullish(),
    place: z.string().nullish(),
    setting_type: z.string().nullish(),
    period: z.string().nullish(),
    city: z.string().nullish(),
    region: z.string().nullish(),
    country_code: z.string().nullish(),
    country_name: z.string().nullish(),
    decades: z.array(z.int()).optional().default([]),
    year_from: z.int().nullish(),
    year_to: z.int().nullish(),
    setting_kind: z.string().nullish(),
    description: z.string().nullish(),
    is_primary: z.boolean().optional().default(false)
});

/**
 * GalleyEssenceDetails
 */
export const zGalleyEssenceDetails = z.object({
    synopsis: z.string().nullish(),
    settings: z.array(zGalleySetting).optional().default([]),
    characters: z.array(zGalleyCharacter).optional().default([]),
    trope_reasons: z.array(z.string()).optional().default([]),
    metaphysics: z.string().nullish(),
    metaphysics_description: z.string().nullish(),
    social_structure: z.string().nullish(),
    social_structure_description: z.string().nullish()
});

/**
 * GenreFilter
 */
export const zGenreFilter = z.object({
    genres: z.array(z.string()).min(1)
});

/**
 * Granularity
 *
 * Time-bucket size for the sales series.
 */
export const zGranularity = z.enum([
    'daily',
    'weekly',
    'monthly'
]);

/**
 * BookSalesRange
 *
 * Echoes the resolved window so the client can label the chart.
 *
 * `granularity` is the effective bucket size actually served (the requested
 * one, clamped into `availableGranularities` when it didn't fit the span).
 * `availableGranularities` is the full set valid for this window, so the
 * client drives its granularity picker entirely from the response.
 */
export const zBookSalesRange = z.object({
    start: z.string(),
    end: z.string(),
    granularity: zGranularity,
    availableGranularities: z.array(zGranularity)
});

/**
 * AmazonSalesResponse
 */
export const zAmazonSalesResponse = z.object({
    type: z.literal('amazon'),
    isbn: z.string(),
    range: zBookSalesRange,
    currency: z.string().nullable(),
    buckets: z.array(zAmazonSalesBucket),
    summary: zAmazonSalesSummary
});

/**
 * BookSalesResponse
 */
export const zBookSalesResponse = z.object({
    type: z.literal('market'),
    isbn: z.string(),
    range: zBookSalesRange,
    markets: z.array(zBookSalesMarketMeta),
    buckets: z.array(zBookSalesBucket),
    peak: zBookSalesPeak.nullish()
});

/**
 * ImprintFilter
 */
export const zImprintFilter = z.object({
    imprints: z.array(z.string()).min(1)
});

/**
 * IsbnsFilter
 */
export const zIsbnsFilter = z.object({
    isbns: z.array(z.string()).min(1)
});

/**
 * KeywordCountFilter
 */
export const zKeywordCountFilter = z.object({
    operator: zFilterOperator,
    value: z.int().gte(0)
});

/**
 * KeywordFeedbackCategory
 */
export const zKeywordFeedbackCategory = z.enum([
    'wrong_association',
    'poor_fit',
    'duplicate_redundant',
    'other'
]);

/**
 * KeywordFeedbackResponse
 */
export const zKeywordFeedbackResponse = z.object({
    id: z.string()
});

/**
 * ApiResponseKeywordFeedbackResponseStatus200
 */
export const zApiResponseKeywordFeedbackResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zKeywordFeedbackResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ApiResponseKeywordFeedbackResponseStatus201
 */
export const zApiResponseKeywordFeedbackResponseStatus201 = z.object({
    success: z.boolean().optional().default(true),
    data: zKeywordFeedbackResponse.nullish(),
    code: z.int().optional().default(201)
});

/**
 * KeywordFeedbackSubCategory
 */
export const zKeywordFeedbackSubCategory = z.enum([
    'inappropriate',
    'unrelated_reference',
    'irrelevant',
    'too_seasonal',
    'too_general',
    'repeat',
    'metadata_reference',
    'other'
]);

/**
 * KeywordFeedbackDetails
 */
export const zKeywordFeedbackDetails = z.object({
    category: zKeywordFeedbackCategory,
    subCategory: zKeywordFeedbackSubCategory.nullish(),
    freeText: z.string().max(2000).nullish()
});

/**
 * KeywordFeedbackRequest
 */
export const zKeywordFeedbackRequest = z.object({
    keyword: z.string().min(1).max(500),
    feedback: zKeywordFeedbackDetails.nullish(),
    discarded: z.boolean().optional().default(false)
});

/**
 * KeywordsFilter
 */
export const zKeywordsFilter = z.object({
    keywords: z.array(z.string()).min(1)
});

/**
 * ManuscriptUploadRequest
 *
 * Request model for uploading just a manuscript with minimal product data
 */
export const zManuscriptUploadRequest = z.object({
    manuscript: z.string()
});

/**
 * OnixExportStatus
 */
export const zOnixExportStatus = z.enum([
    'REQUESTED',
    'PROCESSING',
    'COMPLETED',
    'ERROR'
]);

/**
 * OnixImportReportErrorResponse
 */
export const zOnixImportReportErrorResponse = z.object({
    error: z.string(),
    code: z.int()
});

/**
 * OnixImportReportScheduleRequest
 */
export const zOnixImportReportScheduleRequest = z.object({
    onixImportReportId: z.string().min(1)
});

/**
 * OnixImportReportScheduleResponse
 */
export const zOnixImportReportScheduleResponse = z.object({
    exportId: z.string()
});

/**
 * OrganisationShort
 */
export const zOrganisationShort = z.object({
    id: z.string(),
    name: z.string()
});

export const zProductAvailabilityCodeLiteral = z.enum([
    '01',
    '09',
    '10',
    '11',
    '12',
    '20',
    '21',
    '22',
    '23',
    '30',
    '31',
    '32',
    '33',
    '34',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '50',
    '51',
    '52',
    '97',
    '98',
    '99'
]);

/**
 * AccountOrganisationSettingsUpdateRequest
 */
export const zAccountOrganisationSettingsUpdateRequest = z.object({
    inactiveProductStatus: z.array(zProductAvailabilityCodeLiteral).nullish(),
    excludeNoAvailabilityCode: z.boolean().nullish(),
    language: zFirestoreOrganisationLanguage.nullish(),
    marketplace: zFirestoreOrganisationMarketplace.nullish()
});

/**
 * FirestoreOrganisationSettings
 */
export const zFirestoreOrganisationSettings = z.object({
    inactiveProductStatus: z.array(zProductAvailabilityCodeLiteral).optional(),
    excludeNoAvailabilityCode: z.boolean().optional().default(false),
    canSeeAmazonSearchTerms: z.boolean().nullish().default(false),
    marketplace: zFirestoreOrganisationMarketplace.nullish().default('NONE'),
    language: zFirestoreOrganisationLanguage.nullish().default('en-US'),
    acpSettings: zFirestoreOrganisationAcpSettings.nullish(),
    salesDataLake: zFirestoreOrganisationSalesDataLake.optional().default('DISABLED')
});

/**
 * AccountOrganisationCreateRequest
 */
export const zAccountOrganisationCreateRequest = z.object({
    name: z.string(),
    emails: z.array(z.string()).nullish(),
    targetGroups: z.array(zFirestoreOrganisationTargetGroups).nullish().default([]),
    disablePromptGuard: z.boolean().nullish().default(false),
    settings: zFirestoreOrganisationSettings.optional(),
    descriptionsDefault: z.string().nullish().default('Description'),
    descriptionsTypes: z.record(z.string(), z.int()).nullish().default({}),
    createdAt: z.iso.datetime().optional(),
    deletedAt: z.iso.datetime().nullish(),
    hardDeletedAt: z.iso.datetime().nullish()
});

/**
 * AccountOrganisationResponse
 */
export const zAccountOrganisationResponse = z.object({
    id: z.string(),
    name: z.string(),
    emails: z.array(z.string()).nullish().default([]),
    targetGroups: z.array(zFirestoreOrganisationTargetGroups).nullish().default([]),
    disablePromptGuard: z.boolean().nullish().default(false),
    settings: zFirestoreOrganisationSettings.optional(),
    descriptionsDefault: z.string().nullish().default('Description'),
    descriptionsTypes: z.record(z.string(), z.int()).nullish().default({}),
    createdAt: z.iso.datetime().optional(),
    deletedAt: z.iso.datetime().nullish(),
    hardDeletedAt: z.iso.datetime().nullish()
});

/**
 * AccountOrganisationUpdateRequest
 */
export const zAccountOrganisationUpdateRequest = z.object({
    name: z.string().nullish(),
    emails: z.array(z.string()).nullish(),
    targetGroups: z.array(zFirestoreOrganisationTargetGroups).nullish().default([]),
    disablePromptGuard: z.boolean().nullish().default(false),
    settings: zFirestoreOrganisationSettings.optional(),
    descriptionsDefault: z.string().nullish().default('Description'),
    descriptionsTypes: z.record(z.string(), z.int()).nullish().default({}),
    createdAt: z.iso.datetime().optional(),
    deletedAt: z.iso.datetime().nullish(),
    hardDeletedAt: z.iso.datetime().nullish()
});

/**
 * AccountOrganisationsResponse
 */
export const zAccountOrganisationsResponse = z.object({
    items: z.array(zAccountOrganisationResponse).optional().default([])
});

/**
 * ApiResponseAccountOrganisationResponseStatus200
 */
export const zApiResponseAccountOrganisationResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zAccountOrganisationResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ApiResponseAccountOrganisationsResponseStatus200
 */
export const zApiResponseAccountOrganisationsResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zAccountOrganisationsResponse.nullish(),
    code: z.int().optional().default(200)
});

export const zProductAvailabilityNameLiteral = z.enum([
    'Cancelled',
    'Not_yet_available_postponed_indefinitely',
    'Not_yet_available',
    'Awaiting_stock',
    'Not_yet_available_will_be_POD',
    'Available',
    'In_stock',
    'To_order',
    'POD',
    'Temporarily_unavailable',
    'Out_of_stock',
    'Reprinting',
    'Awaiting_reissue',
    'Temporarily_withdrawn_from_sale',
    'Not_available_reason_unspecified',
    'Not_available_replaced_by_new_product',
    'Not_available_other_format_available',
    'No_longer_supplied_by_the_supplier',
    'Apply_direct',
    'Not_sold_separately',
    'Withdrawn_from_sale',
    'Remaindered',
    'Not_available_replaced_by_POD',
    'Recalled',
    'Not_sold_as_set',
    'Not_available_publisher_indicates_OP',
    'Not_available_publisher_no_longer_sells_product_in_this_market',
    'No_recent_update_received',
    'No_longer_receiving_updates',
    'Contact_supplier'
]);

/**
 * FirestoreProductSupplyDetail
 */
export const zFirestoreProductSupplyDetail = z.object({
    supplierName: z.string().nullish(),
    supplierRole: z.string().nullish(),
    availability: zProductAvailabilityNameLiteral.optional().default('Contact_supplier')
});

export const zProductFormCodeLiteral = z.enum([
    '00',
    'AA',
    'AB',
    'AC',
    'AD',
    'AE',
    'AF',
    'AG',
    'AH',
    'AI',
    'AJ',
    'AK',
    'AL',
    'AM',
    'AN',
    'AO',
    'AZ',
    'BA',
    'BB',
    'BC',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BK',
    'BL',
    'BM',
    'BN',
    'BO',
    'BP',
    'BZ',
    'CA',
    'CB',
    'CC',
    'CD',
    'CE',
    'CZ',
    'DA',
    'DB',
    'DC',
    'DE',
    'DF',
    'DI',
    'DJ',
    'DK',
    'DL',
    'DM',
    'DN',
    'DO',
    'DZ',
    'EA',
    'EB',
    'EC',
    'ED',
    'FA',
    'FC',
    'FD',
    'FE',
    'FF',
    'FZ',
    'LA',
    'LB',
    'LC',
    'MA',
    'MB',
    'MC',
    'MZ',
    'PA',
    'PB',
    'PC',
    'PD',
    'PE',
    'PF',
    'PG',
    'PH',
    'PI',
    'PJ',
    'PK',
    'PL',
    'PM',
    'PN',
    'PO',
    'PP',
    'PQ',
    'PR',
    'PS',
    'PT',
    'PU',
    'PV',
    'PZ',
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SF',
    'SG',
    'VA',
    'VF',
    'VI',
    'VJ',
    'VK',
    'VL',
    'VM',
    'VN',
    'VO',
    'VP',
    'VQ',
    'VZ',
    'XA',
    'XB',
    'XC',
    'XD',
    'XE',
    'XF',
    'XG',
    'XH',
    'XI',
    'XJ',
    'XK',
    'XL',
    'XM',
    'XN',
    'XO',
    'XY',
    'XZ',
    'ZA',
    'ZB',
    'ZC',
    'ZD',
    'ZE',
    'ZF',
    'ZG',
    'ZH',
    'ZI',
    'ZJ',
    'ZK',
    'ZL',
    'ZM',
    'ZN',
    'ZO',
    'ZP',
    'ZX',
    'ZY',
    'ZZ'
]);

export const zProductFormDescLiteral = z.enum([
    'Undefined',
    'Audio',
    'Audio cassette',
    'CD-Audio',
    'DAT',
    'Audio disc',
    'Audio tape',
    'MiniDisc',
    'CD-Extra',
    'DVD Audio',
    'Downloadable audio file',
    'Pre-recorded digital audio player',
    'Pre-recorded SD card',
    'LP',
    'Downloadable and online audio file',
    'Online audio file',
    'Other audio format',
    'Book',
    'Hardback',
    'Paperback / softback',
    'Loose-leaf',
    'Spiral bound',
    'Pamphlet',
    'Leather / fine binding',
    'Board book',
    'Rag book',
    'Bath book',
    'Novelty book',
    'Slide bound',
    'Big book',
    'Part-work (fascículo)',
    'Fold-out book or chart',
    'Foam book',
    'Other book format',
    'Sheet map',
    'Sheet map, folded',
    'Sheet map, flat',
    'Sheet map, rolled',
    'Globe',
    'Other cartographic',
    'Digital (on physical carrier)',
    'CD-ROM',
    'CD-I',
    'Game cartridge',
    'Diskette',
    'DVD-ROM',
    'Secure Digital (SD) Memory Card',
    'Compact Flash Memory Card',
    'Memory Stick Memory Card',
    'USB Flash Drive',
    'Double-sided CD/DVD',
    'BR-ROM',
    'Other digital carrier',
    'Digital (delivered electronically)',
    'Digital download and online',
    'Digital online',
    'Digital download',
    'Film or transparency',
    'Slides',
    'OHP transparencies',
    'Filmstrip',
    'Film',
    'Other film or transparency format',
    'Digital product license',
    'Digital product license key',
    'Digital product license code',
    'Microform',
    'Microfiche',
    'Microfilm',
    'Other microform',
    'Miscellaneous print',
    'Address book',
    'Calendar',
    'Cards',
    'Copymasters',
    'Diary or journal',
    'Frieze',
    'Kit',
    'Sheet music',
    'Postcard book or pack',
    'Poster',
    'Record book',
    'Wallet or folder',
    'Pictures or photographs',
    'Wallchart',
    'Stickers',
    'Plate (lámina)',
    'Notebook / blank book',
    'Organizer',
    'Bookmark',
    'Leaflet',
    'Book plates',
    'Other printed item',
    'Multiple-component retail product',
    'Multiple-component retail product, boxed',
    'Multiple-component retail product, slip-cased',
    'Multiple-component retail product, shrink-wrapped',
    'Multiple-component retail product, loose',
    'Multiple-component retail product, part(s) enclosed',
    'Multiple-component retail product, entirely digital',
    'Video',
    'Videodisc',
    'DVD video',
    'VHS video',
    'Betamax video',
    'VCD',
    'SVCD',
    'HD DVD',
    'Blu-ray',
    'UMD Video',
    'CBHD',
    'Other video format',
    'Trade-only material',
    'Dumpbin – empty',
    'Dumpbin – filled',
    'Counterpack – empty',
    'Counterpack – filled',
    'Poster, promotional',
    'Shelf strip',
    'Window piece',
    'Streamer',
    'Spinner – empty',
    'Large book display',
    'Shrink-wrapped pack',
    'Boxed pack',
    'Pack (outer packaging unspecified)',
    'Spinner – filled',
    'Other point of sale – including retail product',
    'Other point of sale',
    'General merchandise',
    'Doll or figure',
    'Soft toy',
    'Toy',
    'Game',
    'T-shirt',
    'E-book reader',
    'Tablet computer',
    'Audiobook player',
    'Jigsaw',
    'Mug',
    'Tote bag',
    'Tableware',
    'Umbrella',
    'Paints, crayons, pencils',
    'Handicraft kit',
    'Other toy/game accessories',
    'Other apparel',
    'Other merchandise'
]);

/**
 * ProductAPlusPageSummary
 */
export const zProductAPlusPageSummary = z.object({
    generation: zAPlusGenerationSummary.nullable()
});

/**
 * ProductAcpFeedPreviewResponse
 */
export const zProductAcpFeedPreviewResponse = z.object({
    id: z.string(),
    is_eligible_search: z.boolean(),
    is_eligible_checkout: z.boolean(),
    acp_product: zAcpProduct
});

/**
 * ApiResponseProductAcpFeedPreviewResponseStatus200
 */
export const zApiResponseProductAcpFeedPreviewResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductAcpFeedPreviewResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProductAmplifyAPlusContentResponse
 *
 * A+ content status for a product, as reported by Amplify.
 *
 * Both URLs are null unless there is something to link to. See
 * docs/amplify-integration.md.
 */
export const zProductAmplifyAPlusContentResponse = z.object({
    status: zAPlusContentStatus,
    amazonUrl: z.string().nullable(),
    amplifyUrl: z.string().nullable(),
    modules: z.array(zAPlusContentModule)
});

/**
 * ApiResponseProductAmplifyAPlusContentResponseStatus200
 */
export const zApiResponseProductAmplifyAPlusContentResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductAmplifyAPlusContentResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProductAmplifySummary
 *
 * A product as Amplify reports it. See docs/amplify-integration.md.
 */
export const zProductAmplifySummary = z.object({
    id: z.string(),
    aPlusPage: zProductAPlusPageSummary.nullable()
});

/**
 * ProductCreationResponse
 */
export const zProductCreationResponse = z.object({
    id: z.string(),
    manuscriptFilename: z.string().nullish()
});

/**
 * ApiResponseProductCreationResponseStatus200
 */
export const zApiResponseProductCreationResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductCreationResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProductDeletionResponse
 */
export const zProductDeletionResponse = z.object({
    id: z.string(),
    success: z.boolean(),
    message: z.string()
});

/**
 * ApiResponseProductDeletionResponseStatus200
 */
export const zApiResponseProductDeletionResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductDeletionResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProductGenerationRequestDescription
 */
export const zProductGenerationRequestDescription = z.object({
    hash: z.string().nullish(),
    specialRequest: z.string().nullish(),
    targetGroup: z.string().nullish()
});

/**
 * ProductGenerationRequestDescriptionBulkFilter
 */
export const zProductGenerationRequestDescriptionBulkFilter = z.object({
    textType: z.string().nullish(),
    audience: z.string().nullish()
});

/**
 * ProductGenerationRequestDescriptionBulk
 */
export const zProductGenerationRequestDescriptionBulk = z.object({
    specialRequest: z.string().nullish(),
    targetGroup: z.string().nullish(),
    identifiers: z.array(z.string()),
    filters: z.array(zProductGenerationRequestDescriptionBulkFilter).optional()
});

/**
 * ProductGenerationRequestKeywords
 */
export const zProductGenerationRequestKeywords = z.object({
    generate: z.boolean().optional().default(false),
    forceGenerate: z.boolean().optional().default(false),
    rank: z.boolean().optional().default(false),
    autoFill: z.boolean().optional().default(false)
});

/**
 * ProductGenerationRequestKeywordsBulk
 */
export const zProductGenerationRequestKeywordsBulk = z.object({
    generate: z.boolean().optional().default(false),
    forceGenerate: z.boolean().optional().default(false),
    rank: z.boolean().optional().default(false),
    autoFill: z.boolean().optional().default(false),
    identifiers: z.array(z.string())
});

/**
 * ProductGenerationRequestManuscript
 */
export const zProductGenerationRequestManuscript = z.record(z.string(), z.unknown());

/**
 * ProductGenerationRequestSubtitle
 */
export const zProductGenerationRequestSubtitle = z.object({
    specialRequest: z.string().nullish()
});

/**
 * ProductGenerationRequestThemaBulk
 */
export const zProductGenerationRequestThemaBulk = z.object({
    identifiers: z.array(z.string())
});

/**
 * ProductGenerationResponse
 */
export const zProductGenerationResponse = z.object({
    generationRequestId: z.string()
});

/**
 * ApiResponseProductGenerationResponseStatus200
 */
export const zApiResponseProductGenerationResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductGenerationResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProductGenerationResponseBulk
 */
export const zProductGenerationResponseBulk = z.object({
    generationRequestIds: z.array(z.string()),
    failedRequests: z.array(zFailedRequestInfo).optional().default([])
});

/**
 * ApiResponseProductGenerationResponseBulkStatus200
 */
export const zApiResponseProductGenerationResponseBulkStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductGenerationResponseBulk.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProductGroupDescriptionFilter
 */
export const zProductGroupDescriptionFilter = z.object({
    productGroupDescriptions: z.array(z.string()).min(1)
});

/**
 * ProductIdsFilter
 */
export const zProductIdsFilter = z.object({
    product_ids: z.array(z.string()).min(1)
});

/**
 * ProductRawResponse
 */
export const zProductRawResponse = z.object({
    id: z.string(),
    header: z.record(z.string(), z.unknown()).optional(),
    baseProduct: z.record(z.string(), z.unknown()).optional(),
    rawOnixV3: z.record(z.string(), z.unknown()).optional()
});

/**
 * ApiResponseProductRawResponseStatus200
 */
export const zApiResponseProductRawResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductRawResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProductSource
 */
export const zProductSource = z.enum(['ONIX_IMPORT', 'MANUSCRIPT_ONLY']);

/**
 * ProductsAmplifySummariesRequest
 */
export const zProductsAmplifySummariesRequest = z.object({
    productIds: z.array(z.string())
});

/**
 * ProductsAmplifySummariesResponse
 */
export const zProductsAmplifySummariesResponse = z.object({
    products: z.array(zProductAmplifySummary)
});

/**
 * ApiResponseProductsAmplifySummariesResponseStatus200
 */
export const zApiResponseProductsAmplifySummariesResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductsAmplifySummariesResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProductsCsvExportRequest
 */
export const zProductsCsvExportRequest = z.object({
    identifiers: z.array(z.string()),
    audience: z.string().nullish(),
    textType: z.string().nullish()
});

/**
 * ProductsExportRequest
 */
export const zProductsExportRequest = z.object({
    productIds: z.array(z.string())
});

/**
 * ProductsExportResponse
 */
export const zProductsExportResponse = z.object({
    id: z.string(),
    productIds: z.array(z.string()).optional().default([]),
    status: zOnixExportStatus,
    downloadUrl: z.string().nullish()
});

/**
 * ApiResponseProductsExportResponseStatus200
 */
export const zApiResponseProductsExportResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductsExportResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProjectAmplifyProductsRequest
 */
export const zProjectAmplifyProductsRequest = z.object({
    productIds: z.array(z.string()).min(1).max(250)
});

/**
 * ProjectAmplifyProductsResponse
 */
export const zProjectAmplifyProductsResponse = z.object({
    amplifyProjectId: z.string(),
    addedCount: z.int(),
    startedGenerations: z.int(),
    skippedGenerations: z.int(),
    failedGenerations: z.int()
});

/**
 * ApiResponseProjectAmplifyProductsResponseStatus200
 */
export const zApiResponseProjectAmplifyProductsResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProjectAmplifyProductsResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * PublishedAtFilter
 */
export const zPublishedAtFilter = z.object({
    gte: z.iso.datetime(),
    lte: z.iso.datetime()
});

/**
 * PublishedByFilter
 */
export const zPublishedByFilter = z.object({
    publishers: z.array(z.string()).min(1)
});

/**
 * GalleyProductFilters
 */
export const zGalleyProductFilters = z.object({
    published_by: zPublishedByFilter.nullish(),
    product_group_description: zProductGroupDescriptionFilter.nullish(),
    published_at: zPublishedAtFilter.nullish()
});

/**
 * GalleySearchRequest
 */
export const zGalleySearchRequest = z.object({
    query: z.string().max(1000),
    page: z.int().gte(1).optional().default(1),
    per_page: z.int().gte(1).lte(50).optional().default(10),
    filters: zGalleyProductFilters.nullish(),
    essence_filters: zGalleyEssenceFilters.nullish(),
    facets: z.array(z.union([z.enum([
            'publishers',
            'imprints',
            'productGroupDescription',
            'author',
            'genre',
            'keywords',
            'themaCodes',
            'bisacCodes'
        ]), z.enum([
            'essence.genres',
            'essence.tropes',
            'essence.countries',
            'essence.decades',
            'essence.characterRoles',
            'essence.protagonistPronouns'
        ])])).optional().default([])
});

/**
 * SalesInfoResponse
 *
 * Window-independent sales metadata for the selected book(s): the earliest
 * sale date per source, the data-freshness signal, and the markets the book
 * has sold into. Everything here is computed over all history so the client
 * can anchor the date picker, the pre-order banner, and a stable market order.
 *
 * `market` is the first `sales_market` (industry panel) date across the
 * selected ISBNs; `amazon` is the first Amazon ordered-sales date for the
 * primary ISBN (pre-orders included). Both are ISO dates (YYYY-MM-DD) or null
 * when the source has no rows.
 */
export const zSalesInfoResponse = z.object({
    market: z.string().nullable(),
    amazon: z.string().nullable(),
    lastSyncedAt: z.string().nullable(),
    markets: z.array(z.string())
});

/**
 * ApiResponseSalesInfoResponseStatus200
 */
export const zApiResponseSalesInfoResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zSalesInfoResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * SalesResponse
 *
 * Unified `GET /books/sales` contract, discriminated by the `type` field:
 * `market` yields `BookSalesResponse`, `amazon` yields `AmazonSalesResponse`.
 */
export const zSalesResponse = z.discriminatedUnion('type', [
    zBookSalesResponse,
    zAmazonSalesResponse
]);

/**
 * ApiResponseSalesResponseStatus200
 */
export const zApiResponseSalesResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zSalesResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * SalesSearchMetric
 */
export const zSalesSearchMetric = z.enum([
    'total_units',
    'amazon_ordered_units',
    'amazon_conversion_rate'
]);

/**
 * ProductSearchSalesMetricCriterion
 */
export const zProductSearchSalesMetricCriterion = z.object({
    metric: zSalesSearchMetric,
    operator: zFilterOperator,
    value: z.union([
        z.number().gte(0),
        z.string()
    ])
});

/**
 * SalesMetricsFilter
 */
export const zSalesMetricsFilter = z.object({
    start: z.iso.date().nullish().default('2010-01-01'),
    end: z.iso.date().nullish(),
    criteria: z.array(zProductSearchSalesMetricCriterion).min(1)
});

/**
 * SeasonalEventDateKind
 */
export const zSeasonalEventDateKind = z.enum([
    'actual',
    'observed',
    'campaign'
]);

/**
 * SeasonalEventRegion
 */
export const zSeasonalEventRegion = z.enum([
    'us',
    'uk',
    'de',
    'aus',
    'international'
]);

/**
 * GalleySeasonalEvent
 */
export const zGalleySeasonalEvent = z.object({
    event_id: z.string(),
    display_name: z.string(),
    region: zSeasonalEventRegion,
    start: z.iso.date(),
    end: z.iso.date(),
    date_kind: zSeasonalEventDateKind,
    days_until: z.int(),
    lead_time_months: z.int(),
    planning_starts: z.iso.date(),
    categories: z.array(z.string()).optional().default([]),
    description: z.string().nullish(),
    evidence: z.array(z.string()).optional().default([]),
    prompts: z.array(zGalleySeasonalEventPrompt).optional().default([])
});

/**
 * GalleySeasonalEventList
 */
export const zGalleySeasonalEventList = z.object({
    regions: z.array(zSeasonalEventRegion),
    window_start: z.iso.date(),
    window_end: z.iso.date(),
    events: z.array(zGalleySeasonalEvent)
});

/**
 * ApiResponseGalleySeasonalEventListStatus200
 */
export const zApiResponseGalleySeasonalEventListStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zGalleySeasonalEventList.nullish(),
    code: z.int().optional().default(200)
});

/**
 * SeriesIdsFilter
 */
export const zSeriesIdsFilter = z.object({
    series_ids: z.array(z.string()).min(1)
});

/**
 * SeriesLevel
 */
export const zSeriesLevel = z.enum(['collection', 'subcollection']);

/**
 * SeriesNumberSource
 */
export const zSeriesNumberSource = z.enum(['collection_sequence', 'part_number']);

/**
 * SeriesOrderType
 *
 * ONIX List 197 (collection sequence type).
 */
export const zSeriesOrderType = z.enum([
    'proprietary',
    'title_order',
    'publication_order',
    'temporal_narrative_order',
    'original_publication_order',
    'suggested_reading_order',
    'suggested_display_order'
]);

/**
 * FirestoreProductSeriesItem
 *
 * One ONIX <Collection> the product belongs to, as the publisher sent it.
 */
export const zFirestoreProductSeriesItem = z.object({
    title: z.string().nullish(),
    level: zSeriesLevel.nullish(),
    number: z.string().nullish(),
    numberSource: zSeriesNumberSource.nullish(),
    orderType: zSeriesOrderType.nullish(),
    identifiers: z.array(zFirestoreProductSeriesIdentifier).optional().default([])
});

/**
 * SeriesStatus
 */
export const zSeriesStatus = z.enum([
    'in_series',
    'not_in_series',
    'unknown'
]);

/**
 * FirestoreProductSeries
 */
export const zFirestoreProductSeries = z.object({
    status: zSeriesStatus.optional().default('unknown'),
    items: z.array(zFirestoreProductSeriesItem).optional().default([])
});

/**
 * Product
 *
 * Excludes internal fields like organisationId and embedding source text.
 */
export const zProduct = z.object({
    id: z.string(),
    identifier: z.string(),
    title: z.string(),
    author: z.array(z.string()).optional().default([]),
    description: z.string().nullish(),
    publishers: z.array(z.string()).optional().default([]),
    imprints: z.array(z.string()).optional().default([]),
    productGroupDescription: z.string().optional().default(''),
    genre: z.array(z.string()).optional().default([]),
    keywords: z.array(z.string()).optional().default([]),
    themaCodes: z.array(z.string()).optional().default([]),
    publishedAt: z.iso.datetime().nullish(),
    keywordCount: z.int().optional().default(0),
    descriptionLength: z.int().optional().default(0),
    themaCodeCount: z.int().optional().default(0),
    workId: z.string().nullish(),
    identifiers: z.array(zFirestoreProductIdentifier).optional().default([]),
    dimensions: zFirestoreProductDimensions.nullish(),
    images: zFirestoreProductImages.optional(),
    quotes: z.array(zFirestoreProductQuote).optional().default([]),
    seriesIds: z.array(z.string()).optional().default([]),
    series: zFirestoreProductSeries.optional(),
    createdAt: z.iso.datetime().nullish(),
    updatedAt: z.iso.datetime().nullish()
});

/**
 * GalleyBookResponse
 */
export const zGalleyBookResponse = z.object({
    document: zProduct,
    work_id: z.string().nullish(),
    essence: zGalleyEssenceSummary.nullish(),
    essence_details: zGalleyEssenceDetails.nullish()
});

/**
 * ApiResponseGalleyBookResponseStatus200
 */
export const zApiResponseGalleyBookResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zGalleyBookResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * GalleySearchHit
 */
export const zGalleySearchHit = z.object({
    document: zProduct,
    score: z.number().nullish(),
    matched_queries: z.array(z.string()).optional().default([]),
    work_id: z.string().nullish(),
    essence: zGalleyEssenceSummary.nullish(),
    match_reasons: z.array(z.string()).optional().default([])
});

/**
 * GalleySearchResponse
 */
export const zGalleySearchResponse = z.object({
    hits: z.array(zGalleySearchHit),
    found: z.int(),
    took_ms: z.int(),
    page: z.int(),
    per_page: z.int(),
    aggregations: z.array(zAggregationBucket).nullish()
});

/**
 * ApiResponseGalleySearchResponseStatus200
 */
export const zApiResponseGalleySearchResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zGalleySearchResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ProductSearchHit
 */
export const zProductSearchHit = z.object({
    document: zProduct,
    score: z.number().nullish(),
    matched_queries: z.array(z.string()).optional().default([])
});

/**
 * ProductSearchResponse
 */
export const zProductSearchResponse = z.object({
    hits: z.array(zProductSearchHit),
    found: z.int(),
    took_ms: z.int(),
    page: z.int(),
    per_page: z.int(),
    aggregations: z.array(zAggregationBucket).nullish(),
    age_range_available_bounds: zAgeRangeAvailableBounds.nullish()
});

/**
 * ApiResponseProductSearchResponseStatus200
 */
export const zApiResponseProductSearchResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductSearchResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * SubjectSource
 */
export const zSubjectSource = z.enum([
    'GENERATED',
    'DATABASE',
    'MANUAL'
]);

/**
 * FirestoreProductBisacSubject
 *
 * A BISAC code on a product, ordered by list position until the user selects it.
 *
 * A ``MANUAL`` entry is always ``final``: it exists only because the user selected
 * it, and an entry that is neither ``inSource`` nor ``final`` is deleted on the next
 * import.
 */
export const zFirestoreProductBisacSubject = z.object({
    id: z.string(),
    subjectCode: z.string().optional().default(''),
    subjectHeadingText: z.string().nullish(),
    source: zSubjectSource.optional().default('DATABASE'),
    inSource: z.boolean().optional().default(false),
    final: z.boolean().optional().default(false),
    orderIndex: z.int().nullish(),
    seq: z.int().nullish()
});

/**
 * FirestoreProductSubject
 */
export const zFirestoreProductSubject = z.object({
    id: z.string().nullish(),
    responseId: z.string().nullish(),
    source: zSubjectSource.nullish().default('MANUAL'),
    subjectCode: z.string().nullish(),
    subjectHeadingText: z.string().nullish(),
    reasoning: z.string().nullish(),
    subjectSchemeIdentifier: z.string().nullish(),
    ranking: z.int().nullish(),
    rankingReasoning: z.string().nullish(),
    keywordSearchQuery: z.string().nullish(),
    databaseIndex: z.int().nullish(),
    hotnessScore: z.number().nullish()
});

/**
 * FirestoreProductSubjects
 */
export const zFirestoreProductSubjects = z.object({
    generated: z.array(zFirestoreProductSubject).nullish(),
    database: z.array(zFirestoreProductSubject).nullish(),
    final: z.array(zFirestoreProductSubject).nullish(),
    finalWords: z.array(zFirestoreProductSubject).nullish(),
    bisac: z.array(zFirestoreProductBisacSubject).optional()
});

/**
 * ProductResponse
 */
export const zProductResponse = z.object({
    id: z.string(),
    identifier: z.string(),
    identifierType: z.string().nullish(),
    identifiers: z.array(zFirestoreProductIdentifier).optional().default([]),
    workId: z.string().nullish(),
    importData: zFirestoreProductImportData.nullish(),
    title: z.string(),
    descriptions: z.array(zFirestoreProductDescription).nullish().default([]),
    subtitles: z.array(zFirestoreProductSubtitleCandidate).optional().default([]),
    biography: z.string().nullish(),
    author: z.array(z.string()).optional().default([]),
    genre: z.array(z.string()).optional().default([]),
    keywordCount: z.int().optional().default(0),
    language: z.string(),
    languageOriginal: z.string(),
    organisation: zOrganisationShort,
    productGroup: zProductFormCodeLiteral,
    productGroupDescription: zProductFormDescLiteral,
    publisher: z.string(),
    publishers: z.array(zFirestoreProductPublisher).optional().default([]),
    imprints: z.array(z.string()).optional().default([]),
    publishedAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    subjects: zFirestoreProductSubjects.nullish(),
    forceSyncTriggeredAt: z.iso.datetime().nullish(),
    categorization: zFirestoreProductCategorization.nullish().default({
        fiction: true,
        nonFiction: true,
        children: true,
        updatedAt: null,
        inferredFrom: null
    }),
    sourceType: zProductSource.optional().default('ONIX_IMPORT'),
    manuscript: zFirestoreProductManuscript.nullish(),
    actions: zFirestoreProductActions.optional(),
    isEligibleSearch: z.boolean().optional().default(true),
    isEligibleCheckout: z.boolean().optional().default(false),
    supplyDetails: z.array(zFirestoreProductSupplyDetail).optional(),
    dimensions: zFirestoreProductDimensions.nullish(),
    ageRanges: zFirestoreProductAgeRanges.nullish(),
    images: zFirestoreProductImages.optional(),
    quotes: z.array(zFirestoreProductQuote).optional().default([]),
    series: zFirestoreProductSeries.optional()
});

/**
 * ApiResponseProductResponseStatus200
 */
export const zApiResponseProductResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zProductResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ThemaCodeCountFilter
 */
export const zThemaCodeCountFilter = z.object({
    operator: zFilterOperator,
    value: z.int().gte(0)
});

/**
 * ThemaCodeType
 *
 * Type of Thema-Code.
 */
export const zThemaCodeType = z.enum(['subject', 'qualifier']);

/**
 * ThemaCode
 *
 * Model for a Thema-Code.
 */
export const zThemaCode = z.object({
    id: z.string(),
    code: z.string(),
    description: z.string(),
    type: zThemaCodeType,
    notes: z.string().nullish(),
    parent: z.string().nullish(),
    has_children: z.boolean().optional().default(false),
    level: z.int().optional().default(0),
    children_length: z.int().optional().default(0),
    highlighted_code: z.string().nullish(),
    highlighted_description: z.string().nullish(),
    highlighted_notes: z.string().nullish()
});

/**
 * ThemaCodesFilter
 */
export const zThemaCodesFilter = z.object({
    codes: z.array(z.string()).min(1)
});

/**
 * ProductSearchFilters
 */
export const zProductSearchFilters = z.object({
    keyword_count: zKeywordCountFilter.nullish(),
    description_length: zDescriptionLengthFilter.nullish(),
    description_word_count: zDescriptionWordCountFilter.nullish(),
    thema_code_count: zThemaCodeCountFilter.nullish(),
    bisac_code_count: zBisacCodeCountFilter.nullish(),
    published_at: zPublishedAtFilter.nullish(),
    published_by: zPublishedByFilter.nullish(),
    imprint: zImprintFilter.nullish(),
    isbns: zIsbnsFilter.nullish(),
    series_ids: zSeriesIdsFilter.nullish(),
    product_ids: zProductIdsFilter.nullish(),
    product_group_description: zProductGroupDescriptionFilter.nullish(),
    author: zAuthorFilter.nullish(),
    genre: zGenreFilter.nullish(),
    keywords: zKeywordsFilter.nullish(),
    thema_codes: zThemaCodesFilter.nullish(),
    bisac_codes: zBisacCodesFilter.nullish(),
    sales_metrics: zSalesMetricsFilter.nullish(),
    age_range: zAgeRangeFilter.nullish()
});

/**
 * ProductSearchRequest
 */
export const zProductSearchRequest = z.object({
    query: z.string(),
    use_semantic: z.boolean().optional().default(true),
    use_hybrid: z.boolean().optional().default(false),
    page: z.int().optional().default(1),
    per_page: z.int().gte(0).lte(250).optional().default(50),
    filters: zProductSearchFilters.nullish(),
    aggregations: z.array(z.string()).nullish(),
    aggregation_query: z.string().nullish(),
    aggregation_size: z.int().nullish(),
    include_age_range_bounds: z.boolean().optional().default(false)
});

/**
 * ThemaCodesResponse
 *
 * Response model for THEMA hierarchy navigation (/thema/codes).
 */
export const zThemaCodesResponse = z.object({
    codes: z.array(zThemaCode),
    root_code: z.string().nullish()
});

/**
 * ApiResponseThemaCodesResponseStatus200
 */
export const zApiResponseThemaCodesResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zThemaCodesResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ThemaSearchResponse
 *
 * Response model for THEMA search (/thema/search).
 */
export const zThemaSearchResponse = z.object({
    codes: z.array(zThemaCode),
    total: z.int(),
    page: z.int(),
    per_page: z.int(),
    took_ms: z.int()
});

/**
 * ApiResponseThemaSearchResponseStatus200
 */
export const zApiResponseThemaSearchResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zThemaSearchResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * UpdateFinalKeywordsRequest
 */
export const zUpdateFinalKeywordsRequest = z.object({
    subjects: z.array(zFirestoreProductSubject)
});

/**
 * UserProfile
 */
export const zUserProfile = z.object({
    firstName: z.string(),
    lastName: z.string(),
    photoURL: z.string().nullish()
});

/**
 * ApiResponseUserProfileStatus200
 */
export const zApiResponseUserProfileStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zUserProfile.nullish(),
    code: z.int().optional().default(200)
});

/**
 * UserRole
 */
export const zUserRole = z.enum([
    'SUPER_ADMIN',
    'ADMIN',
    'MEMBER'
]);

/**
 * AccountUserResponse
 */
export const zAccountUserResponse = z.object({
    id: z.string(),
    email: z.string(),
    givenName: z.string().nullish(),
    familyName: z.string().nullish(),
    organisation: zOrganisationShort.nullish(),
    roles: z.array(zUserRole).nullish().default([]),
    deletedAt: z.iso.datetime().nullish()
});

/**
 * AccountUserUpdateRequest
 */
export const zAccountUserUpdateRequest = z.object({
    email: z.string().nullish(),
    givenName: z.string().nullish(),
    familyName: z.string().nullish(),
    roles: z.array(zUserRole).nullish().default([]),
    deletedAt: z.iso.datetime().nullish()
});

/**
 * ApiResponseAccountUserResponseStatus200
 */
export const zApiResponseAccountUserResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zAccountUserResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * OrganisationUserCreateRequest
 */
export const zOrganisationUserCreateRequest = z.object({
    email: z.string(),
    role: zUserRole
});

/**
 * OrganisationUsersCreateRequest
 */
export const zOrganisationUsersCreateRequest = z.object({
    users: z.array(zOrganisationUserCreateRequest).optional()
});

/**
 * UserResponse
 */
export const zUserResponse = z.object({
    id: z.string(),
    userId: z.string(),
    email: z.string(),
    emailVerified: z.boolean().optional().default(false),
    givenName: z.string().nullish(),
    familyName: z.string().nullish(),
    organisation: zOrganisationShort.nullish(),
    apiKeys: z.array(zFirestoreUserApiKey).nullish().default([]),
    roles: z.array(zUserRole).nullish().default([]),
    deletedAt: z.iso.datetime().nullish()
});

/**
 * AccountUsersResponse
 */
export const zAccountUsersResponse = z.object({
    items: z.array(zUserResponse).optional().default([])
});

/**
 * ApiResponseAccountUsersResponseStatus200
 */
export const zApiResponseAccountUsersResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zAccountUsersResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * V1MetadataBlurbRequest
 */
export const zV1MetadataBlurbRequest = z.object({
    inputText: z.string(),
    language: z.string().nullish(),
    theme: z.string().nullish(),
    title: z.string().nullish(),
    author: z.array(z.string()).nullish(),
    publisher: z.string().nullish(),
    format: z.array(zProductFormCodeLiteral).nullish(),
    genre: z.array(z.string()).nullish(),
    keywords: z.array(z.string()).nullish(),
    specialRequest: z.string().nullish(),
    targetGroup: z.string().nullish(),
    targetGroupBook: z.string().nullish(),
    maxLength: z.int().nullish(),
    additionalData: z.unknown().nullish(),
    callbackUrl: z.string().nullish(),
    callbackAuthHeader: z.string().nullish(),
    clientId: z.string(),
    isbn: z.string()
});

/**
 * V1MetadataBlurbResponseData
 */
export const zV1MetadataBlurbResponseData = z.object({
    identifier: z.string(),
    generatedText: z.string(),
    clientId: z.string(),
    isbn: z.string()
});

/**
 * V1MetadataBlurbResponse
 */
export const zV1MetadataBlurbResponse = z.object({
    generation_finished: z.boolean(),
    message: z.string().nullish(),
    metadata: zV1MetadataBlurbResponseData
});

/**
 * ApiResponseV1MetadataBlurbResponseStatus200
 */
export const zApiResponseV1MetadataBlurbResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zV1MetadataBlurbResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * V1MetadataKeywordRequest
 */
export const zV1MetadataKeywordRequest = z.object({
    inputText: z.string(),
    language: z.string().nullish(),
    theme: z.string().nullish(),
    title: z.string().nullish(),
    author: z.array(z.string()).nullish(),
    publisher: z.string().nullish(),
    format: z.array(zProductFormCodeLiteral).nullish(),
    genre: z.array(z.string()).nullish(),
    keywords: z.array(z.string()).nullish(),
    specialRequest: z.string().nullish(),
    targetGroup: z.string().nullish(),
    targetGroupBook: z.string().nullish(),
    maxLength: z.int().nullish(),
    additionalData: z.unknown().nullish(),
    callbackUrl: z.string().nullish(),
    callbackAuthHeader: z.string().nullish(),
    clientId: z.string(),
    isbn: z.string()
});

/**
 * V1MetadataKeywordResponseData
 */
export const zV1MetadataKeywordResponseData = z.object({
    identifier: z.string(),
    generatedKeywords: z.array(z.string()),
    clientId: z.string(),
    isbn: z.string()
});

/**
 * V1MetadataKeywordResponse
 */
export const zV1MetadataKeywordResponse = z.object({
    generation_finished: z.boolean(),
    message: z.string().nullish(),
    metadata: zV1MetadataKeywordResponseData
});

/**
 * ApiResponseV1MetadataKeywordResponseStatus200
 */
export const zApiResponseV1MetadataKeywordResponseStatus200 = z.object({
    success: z.boolean().optional().default(true),
    data: zV1MetadataKeywordResponse.nullish(),
    code: z.int().optional().default(200)
});

/**
 * ValidationErrorDetail
 */
export const zValidationErrorDetail = z.object({
    loc: z.array(z.unknown()),
    type: z.string(),
    msg: z.string()
});

/**
 * ApiResponseValidationError
 */
export const zApiResponseValidationError = z.object({
    message: z.string(),
    errors: z.array(zValidationErrorDetail)
});

/**
 * ApiResponseApiResponseValidationErrorStatus422
 */
export const zApiResponseApiResponseValidationErrorStatus422 = z.object({
    success: z.boolean().optional().default(false),
    data: zApiResponseValidationError.nullish(),
    code: z.int().optional().default(422)
});

/**
 * Success
 */
export const zHealthResponse = zApiResponseApiResponseMessageStatus200;

export const zProductsSearchBody = zProductSearchRequest;

/**
 * Success
 */
export const zProductsSearchResponse = zApiResponseProductSearchResponseStatus200;

export const zGetThemaCodesQuery = z.object({
    type: z.string().optional(),
    parent: z.string().optional(),
    language: z.string().optional()
});

/**
 * Success
 */
export const zGetThemaCodesResponse = zApiResponseThemaCodesResponseStatus200;

export const zSearchThemaQuery = z.object({
    q: z.string(),
    type: z.string().optional(),
    page: z.int().optional(),
    per_page: z.int().optional(),
    language: z.string().optional()
});

/**
 * Success
 */
export const zSearchThemaResponse = zApiResponseThemaSearchResponseStatus200;

/**
 * Success
 */
export const zGetBisacCodesResponse = zApiResponseBisacCodesResponseStatus200;

export const zSearchBisacQuery = z.object({
    q: z.string()
});

/**
 * Success
 */
export const zSearchBisacResponse = zApiResponseBisacSearchResponseStatus200;

/**
 * Success
 */
export const zGetOrganisationsResponse = zApiResponseAccountOrganisationsResponseStatus200;

export const zDeleteOrganisationPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zDeleteOrganisationResponse = zApiResponseAccountOrganisationResponseStatus200;

export const zGetOrganisationPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zGetOrganisationResponse = zApiResponseAccountOrganisationResponseStatus200;

export const zPatchOrganisationBody = zAccountOrganisationUpdateRequest;

export const zPatchOrganisationPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zPatchOrganisationResponse = zApiResponseAccountOrganisationResponseStatus200;

export const zPostChildOrganisationBody = zAccountOrganisationCreateRequest;

export const zPostChildOrganisationPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zPostChildOrganisationResponse = zApiResponseAccountOrganisationResponseStatus200;

export const zUndeleteOrganisationPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zUndeleteOrganisationResponse = zApiResponseAccountOrganisationResponseStatus200;

export const zPostOrganisationBody = zAccountOrganisationCreateRequest;

/**
 * Success
 */
export const zPostOrganisationResponse = zApiResponseAccountOrganisationResponseStatus200;

export const zUpdateOrganisationSettingsBody = zAccountOrganisationSettingsUpdateRequest;

export const zUpdateOrganisationSettingsPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zUpdateOrganisationSettingsResponse = zApiResponseAccountOrganisationResponseStatus200;

export const zGetOrganisationsUsersPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zGetOrganisationsUsersResponse = zApiResponseAccountUsersResponseStatus200;

export const zAddOrganisationUsersBody = zOrganisationUsersCreateRequest;

export const zAddOrganisationUsersPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zAddOrganisationUsersResponse = zApiResponseApiResponseMessageStatus200;

export const zPostUserBody = zAccountUserCreateRequest;

export const zPostUserPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zPostUserResponse = zApiResponseAccountUserResponseStatus200;

export const zDeleteOrganisationUserPath = z.object({
    identifier: z.string(),
    useridentifier: z.string()
});

/**
 * Success
 */
export const zDeleteOrganisationUserResponse = zApiResponseApiResponseMessageStatus200;

export const zGetOrganisationUserPath = z.object({
    identifier: z.string(),
    useridentifier: z.string()
});

/**
 * Success
 */
export const zGetOrganisationUserResponse = zApiResponseAccountUserResponseStatus200;

export const zPatchUserBody = zAccountUserUpdateRequest;

export const zPatchUserPath = z.object({
    identifier: z.string(),
    useridentifier: z.string()
});

/**
 * Success
 */
export const zPatchUserResponse = zApiResponseAccountUserResponseStatus200;

export const zTransferUserOrganisationPath = z.object({
    source_id: z.string(),
    useridentifier: z.string(),
    destination_id: z.string()
});

/**
 * Success
 */
export const zTransferUserOrganisationResponse = zApiResponseAccountUserResponseStatus200;

export const zGetOrganisationUserApiKeysPath = z.object({
    identifier: z.string(),
    useridentifier: z.string()
});

/**
 * Success
 */
export const zGetOrganisationUserApiKeysResponse = zApiResponseAccountUserApiKeysResponseStatus200;

export const zPostOrganisationUserApiKeyBody = zAccountUserApiKeyRequest;

export const zPostOrganisationUserApiKeyPath = z.object({
    identifier: z.string(),
    useridentifier: z.string()
});

/**
 * Success
 */
export const zPostOrganisationUserApiKeyResponse = zApiResponseAccountUserApiKeyCreatedResponseStatus200;

export const zDeleteOrganisationUsersApiKeyPath = z.object({
    identifier: z.string(),
    useridentifier: z.string(),
    apikeyidentifier: z.string()
});

/**
 * Success
 */
export const zDeleteOrganisationUsersApiKeyResponse = zApiResponseApiResponseMessageStatus200;

export const zPostOrganisationFileRouteBody = zAccountOrganisationFileRequest;

export const zPostOrganisationFileRoutePath = z.object({
    identifier: z.string(),
    file_name: z.string()
});

export const zPostOrganisationFileRouteQuery = z.object({
    no_sign: z.boolean().optional()
});

/**
 * Success
 */
export const zPostOrganisationFileRouteResponse = zApiResponseAccountOrganisationFileResponseStatus200;

export const zPostAcpExportBody = zAcpExportRequest;

export const zPostAcpExportPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zPostAcpExportResponse = zAcpExportResponse;

/**
 * Success
 */
export const zGetEvaluationsListResponse = zApiResponseEvaluationsResponseStatus200;

export const zPostEvaluationBody = zEvaluationRequest;

/**
 * Success
 */
export const zPostEvaluationResponse = zApiResponseEvaluationResponseStatus200;

export const zGetEvaluationPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zGetEvaluationResponse = zApiResponseEvaluationResponseStatus200;

export const zCancelEvaluationPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zCancelEvaluationResponse = zApiResponseApiResponseMessageStatus200;

export const zGetProductRawPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zGetProductRawResponse = zApiResponseProductRawResponseStatus200;

export const zGetProductAcpFeedPreviewPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zGetProductAcpFeedPreviewResponse = zApiResponseProductAcpFeedPreviewResponseStatus200;

export const zGetProductAmplifyAPlusContentPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zGetProductAmplifyAPlusContentResponse = zApiResponseProductAmplifyAPlusContentResponseStatus200;

export const zListProductsAmplifySummariesBody = zProductsAmplifySummariesRequest;

/**
 * Success
 */
export const zListProductsAmplifySummariesResponse = zApiResponseProductsAmplifySummariesResponseStatus200;

export const zGenerateProductKeywordsBody = zProductGenerationRequestKeywords;

export const zGenerateProductKeywordsPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zGenerateProductKeywordsResponse = zApiResponseProductGenerationResponseStatus200;

export const zGenerateProductKeywordsBulkBody = zProductGenerationRequestKeywordsBulk;

/**
 * Success
 */
export const zGenerateProductKeywordsBulkResponse = zApiResponseProductGenerationResponseBulkStatus200;

export const zGenerateProductDescriptionBody = zProductGenerationRequestDescription;

export const zGenerateProductDescriptionPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zGenerateProductDescriptionResponse = zApiResponseProductGenerationResponseStatus200;

export const zGenerateProductDescriptionBulkBody = zProductGenerationRequestDescriptionBulk;

/**
 * Success
 */
export const zGenerateProductDescriptionBulkResponse = zApiResponseProductGenerationResponseBulkStatus200;

export const zGenerateProductThemaPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zGenerateProductThemaResponse = zApiResponseProductGenerationResponseStatus200;

export const zGenerateProductThemaBulkBody = zProductGenerationRequestThemaBulk;

/**
 * Success
 */
export const zGenerateProductThemaBulkResponse = zApiResponseProductGenerationResponseBulkStatus200;

export const zGenerateProductSubtitleBody = zProductGenerationRequestSubtitle;

export const zGenerateProductSubtitlePath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zGenerateProductSubtitleResponse = zApiResponseProductGenerationResponseStatus200;

export const zGenerateProductManuscriptAnalysisBody = zProductGenerationRequestManuscript;

export const zGenerateProductManuscriptAnalysisPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zGenerateProductManuscriptAnalysisResponse = zApiResponseProductGenerationResponseStatus200;

export const zExportProductsBody = zProductsExportRequest;

/**
 * Success
 */
export const zExportProductsResponse = zApiResponseProductsExportResponseStatus200;

export const zExportOrganizationBooksCsvBody = zProductsCsvExportRequest;

/**
 * CSV file containing the requested books
 */
export const zExportOrganizationBooksCsvResponse = z.string();

export const zCreateProductFromManuscriptBody = zManuscriptUploadRequest;

/**
 * Success
 */
export const zCreateProductFromManuscriptResponse = zApiResponseProductCreationResponseStatus200;

export const zDeleteProductPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zDeleteProductResponse = zApiResponseProductDeletionResponseStatus200;

export const zUpdateProductFinalKeywordsBody = zUpdateFinalKeywordsRequest;

export const zUpdateProductFinalKeywordsPath = z.object({
    product_id: z.string()
});

/**
 * Keywords updated successfully
 */
export const zUpdateProductFinalKeywordsResponse = z.void();

export const zUpsertProductKeywordFeedbackBody = zKeywordFeedbackRequest;

export const zUpsertProductKeywordFeedbackPath = z.object({
    product_id: z.string(),
    feedback_id: z.string()
});

export const zUpsertProductKeywordFeedbackResponse = z.union([
    zApiResponseKeywordFeedbackResponseStatus200,
    zApiResponseKeywordFeedbackResponseStatus201
]);

export const zAddProjectProductsToAmplifyBody = zProjectAmplifyProductsRequest;

export const zAddProjectProductsToAmplifyPath = z.object({
    project_id: z.string()
});

/**
 * Success
 */
export const zAddProjectProductsToAmplifyResponse = zApiResponseProjectAmplifyProductsResponseStatus200;

export const zGetUserPath = z.object({
    user_id: z.string()
});

/**
 * Success
 */
export const zGetUserResponse = zApiResponseUserProfileStatus200;

export const zGenerateLoginLinkPath = z.object({
    user_id: z.string()
});

/**
 * Success
 */
export const zGenerateLoginLinkResponse = zApiResponseApiResponseMessageStatus200;

export const zGetFilePath = z.object({
    file_type: z.enum([
        'ACP_EXPORT',
        'EVALUATION_REPORT',
        'MANUAL_ONIX_IMPORT',
        'MANUSCRIPT',
        'MANUSCRIPT_VERSION',
        'ONIX_CHUNK',
        'ONIX_EXPORT',
        'ONIX_IMPORT',
        'ONIX_IMPORT_REPORT',
        'TREND',
        'UNKNOWN'
    ]),
    file_name: z.string()
});

/**
 * Success
 */
export const zGetFileResponse = z.string();

export const zPostOnixImportReportScheduleBody = zOnixImportReportScheduleRequest;

/**
 * Success
 */
export const zPostOnixImportReportScheduleResponse = zOnixImportReportScheduleResponse;

export const zGetBookSalesRouteQuery = z.object({
    isbns: z.string(),
    start: z.string(),
    end: z.string(),
    granularity: z.string(),
    type: z.enum(['market', 'amazon']).optional()
});

/**
 * Success
 */
export const zGetBookSalesRouteResponse = zApiResponseSalesResponseStatus200;

export const zGetBookSalesInfoRouteQuery = z.object({
    isbns: z.string()
});

/**
 * Success
 */
export const zGetBookSalesInfoRouteResponse = zApiResponseSalesInfoResponseStatus200;

export const zGalleyProductsSearchBody = zGalleySearchRequest;

/**
 * Success
 */
export const zGalleyProductsSearchResponse = zApiResponseGalleySearchResponseStatus200;

export const zGalleyProductPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zGalleyProductResponse = zApiResponseGalleyBookResponseStatus200;

export const zGalleySeasonalEventsQuery = z.object({
    months: z.int().optional(),
    region: z.enum([
        'us',
        'uk',
        'de',
        'aus',
        'international'
    ]).optional()
});

/**
 * Success
 */
export const zGalleySeasonalEventsResponse = zApiResponseGalleySeasonalEventListStatus200;

export const zGalleyProjectCreateBody = zGalleyProjectCreateRequest;

/**
 * Success
 */
export const zGalleyProjectCreateResponse = zApiResponseGalleyProjectStatus201;

export const zGalleyProjectPath = z.object({
    project_id: z.string()
});

/**
 * Success
 */
export const zGalleyProjectResponse = zApiResponseGalleyProjectStatus200;

export const zV1PostBlurbBody = zV1MetadataBlurbRequest;

/**
 * Success
 */
export const zV1PostBlurbResponse = zApiResponseV1MetadataBlurbResponseStatus200;

export const zV1GetBlurbPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zV1GetBlurbResponse = zApiResponseV1MetadataBlurbResponseStatus200;

export const zV1PostKeywordsBody = zV1MetadataKeywordRequest;

/**
 * Success
 */
export const zV1PostKeywordsResponse = zApiResponseV1MetadataKeywordResponseStatus200;

export const zV1GetKeywordsPath = z.object({
    identifier: z.string()
});

/**
 * Success
 */
export const zV1GetKeywordsResponse = zApiResponseV1MetadataKeywordResponseStatus200;

export const zV1GetProductPath = z.object({
    product_id: z.string()
});

/**
 * Success
 */
export const zV1GetProductResponse = zApiResponseProductResponseStatus200;
